module.exports = "<div class=\"panel-heading\">{{day}}</div>\n"